(function () {
  'use strict';
  if (window.__erFunnelInit) return;
  window.__erFunnelInit = true;

  /* Mobile menu */
  document.addEventListener('click', function (e) {
    var menu = document.querySelector('[data-er-menu]');
    var overlay = document.querySelector('[data-er-overlay]');
    if (e.target.closest('[data-er-menu-open]')) {
      if (menu) menu.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
    }
    if (e.target.closest('[data-er-menu-close]') || e.target.matches('[data-er-overlay]')) {
      if (menu) menu.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
    }
  });

  /* Qty steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-er-qty-btn]');
    if (!btn) return;
    var wrap = btn.closest('[data-er-qty-wrap]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-er-qty]');
    var val = parseInt(input.value, 10) || 1;
    if (btn.getAttribute('data-er-qty-btn') === 'plus') val += 1;
    else val = Math.max(1, val - 1);
    input.value = val;
  });

  /* Variant select -> update price + add button */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-er-variant-select]');
    if (!sel) return;
    var scope = sel.closest('[data-er-product]');
    if (!scope) return;
    var opt = sel.options[sel.selectedIndex];
    var addBtn = scope.querySelector('[data-er-add]');
    if (addBtn) addBtn.setAttribute('data-variant-id', opt.value);
    var priceEl = scope.querySelector('[data-er-price]');
    var money = opt.getAttribute('data-price-money');
    if (priceEl && money) priceEl.textContent = money;
  });

  /* Cart count */
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-er-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function () {});
  }

  /* Toast */
  function showToast(msg) {
    var toast = document.querySelector('[data-er-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'er-toast';
      toast.setAttribute('data-er-toast', '');
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 2200);
  }

  /* AJAX add to cart */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-er-add]');
    if (!btn) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    e.preventDefault();
    var scope = btn.closest('[data-er-product]');
    var qtyInput = scope ? scope.querySelector('[data-er-qty]') : null;
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty }] })
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw x; }); return r.json(); })
      .then(function () {
        btn.textContent = 'Added ✓';
        showToast('Added to cart');
        updateCartCount();
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1200);
      })
      .catch(function (err) {
        btn.textContent = original;
        btn.disabled = false;
        showToast((err && err.description) ? err.description : 'Could not add to cart');
      });
  });

  /* Sticky ATC visibility */
  var sticky = document.querySelector('[data-er-sticky]');
  if (sticky) {
    var onScroll = function () {
      var y = window.scrollY || window.pageYOffset;
      var nearBottom = (window.innerHeight + y) >= (document.body.scrollHeight - 180);
      if (y > 500 && !nearBottom) sticky.classList.add('is-visible');
      else sticky.classList.remove('is-visible');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* FAQ accordion */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-er-faq-q]');
    if (!q) return;
    var item = q.closest('[data-er-faq-item]');
    if (!item) return;
    var open = item.getAttribute('aria-expanded') === 'true';
    item.setAttribute('aria-expanded', open ? 'false' : 'true');
    q.setAttribute('aria-expanded', open ? 'false' : 'true');
  });

  /* Category active state is handled server-side (is-active in Liquid); links reload the page. */

  updateCartCount();
})();
